export default __webpack_public_path__ + "static/video-mobile-f5198d4f4b1592f6035bdde17718e4f1.mp4";